import React, { Dispatch, SetStateAction, ReactNode } from 'react';
//Components
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

type Props = {
  isOpen: boolean,
  callback?: () => void,
  setIsOpen: Dispatch<SetStateAction<boolean>>,
  titleAlert: string,
  textAlert?: string,
  customComponent?: ReactNode,
  btnDanger?: string,
  btnPrimary?: string,
};

export default function AlertConfirm({
  isOpen,
  callback,
  setIsOpen,
  titleAlert,
  textAlert = '',
  customComponent = null,
  btnDanger,
  btnPrimary,
  notVerifiedChecked,
  setNotVerifiedChecked,
}: Props) {
  function closeModal() {
    if (!notVerifiedChecked) {
      setNotVerifiedChecked(true);
    } else {
      setNotVerifiedChecked(false);
    }
    setIsOpen(false);
  }

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={closeModal}
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'>
      <DialogTitle id='alert-dialog-slide-title'>{titleAlert}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-slide-description'>{textAlert}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color='error' variant='contained'>
          Cancelar
        </Button>
        <Button color='success' variant='contained' onClick={callback}>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
